export default function validateAlphabet(word) {
  const re = /^[A-z ']*$/;
  return re.test(word);
}
